import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["disabled"];
import clsx from 'clsx';
import { tv } from 'tailwind-variants';
import { SpriteIcons } from '@/user/components/common';
import { defaultButtonStyle, getIconSizeText, } from './buttonStyle';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TextButton',
    props: {
        color: {},
        className: {},
        mobileSize: {},
        desktopSize: {},
        disabled: { type: Boolean, default: false },
        iconName: {},
        iconPosition: { default: 'left' },
        iconClassName: { default: '' }
    },
    setup(__props) {
        const props = __props;
        const button = tv({
            extend: defaultButtonStyle,
            variants: {
                color: {
                    blue: 'text-blue-700 hover:text-blue-900 disabled:text-blue-200',
                    gray: 'text-gray-600 hover:text-blue-700 disabled:text-gray-300',
                    white: 'text-white hover:text-gray-400 disabled:text-gray-800',
                    red: 'text-red-700 hover:text-red-900 disabled:text-red-200',
                },
                mobileSize: {
                    large: 'text-body-3 gap-8',
                    medium: 'text-body-5 gap-4',
                    small: 'text-caption-1 gap-4',
                },
                desktopSize: {
                    large: 'desktop:text-body-3 desktop:gap-8',
                    medium: 'desktop:text-body-5 desktop:gap-4',
                    small: 'desktop:text-caption-1 desktop:gap-4',
                },
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(_unref(button)({
                    color: props.color,
                    desktopSize: props.desktopSize,
                    mobileSize: props.mobileSize,
                    class: props.className,
                })),
                disabled: props.disabled,
                type: "button"
            }, [
                (props.iconName && props.iconPosition === 'left')
                    ? (_openBlock(), _createBlock(_unref(SpriteIcons), {
                        key: 0,
                        class: _normalizeClass(_unref(clsx)(_unref(getIconSizeText)(props.desktopSize, props.mobileSize), 'shrink-0', props.iconClassName)),
                        name: props.iconName
                    }, null, 8, ["class", "name"]))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default"),
                (props.iconName && props.iconPosition === 'right')
                    ? (_openBlock(), _createBlock(_unref(SpriteIcons), {
                        key: 1,
                        class: _normalizeClass(_unref(clsx)(_unref(getIconSizeText)(props.desktopSize, props.mobileSize), 'shrink-0', props.iconClassName)),
                        name: props.iconName
                    }, null, 8, ["class", "name"]))
                    : _createCommentVNode("", true)
            ], 10, _hoisted_1));
        };
    }
});
